class PlatformSettings {
    apiUrl: string;
    appId: string;
    appSecret: string;
    appUrl: string;

    constructor(apiUrl: string)
    {
        this.apiUrl = apiUrl;
    }
};

export { PlatformSettings };